import React from "react";
import Typography, { ETypo, ETypoColor } from "@Front/Components/DesignSystem/Typography";
import LinkInline from "../../elements/LinkInline";
import { Routes, buildRoute } from "@Front/Config/Routes";
import { ELegalOptions } from "@Front/Components/LayoutTemplates/DefaultLegalDashboard";
import { useDeploymentLineLegalPublisher } from "@Front/Services/DeploymentLineLegalPublisher/DeploymentLineLegalPublisherContext";
import { CGUSection12_1PartA, CGUSection12_1PartB, CGUSection12_1PartC } from "./CGUSection12_1Parts";

export function CGUSection12_1(): React.JSX.Element {
	const pub = useDeploymentLineLegalPublisher();
	return (
		<section>
			<Typography typo={ETypo.TEXT_LG_REGULAR} color={ETypoColor.TEXT_ACCENT}>
				12.1 Propriété intellectuelle de {pub.publisherLegalName}
			</Typography>
			<CGUSection12_1PartA />
			<CGUSection12_1PartB />
			<CGUSection12_1PartC />
		</section>
	);
}

export function CGUSection12_2(): React.JSX.Element {
	return (
		<section>
			<Typography typo={ETypo.TEXT_LG_REGULAR} color={ETypoColor.TEXT_ACCENT}>
				12.2 Propriété intellectuelle des tiers
			</Typography>
			<Typography typo={ETypo.TEXT_MD_REGULAR} color={ETypoColor.TEXT_SECONDARY}>
				Les éléments appartenant à des tiers, tels qu&apos;extrait de films, marques, logo, images, textes, sons, sans que cette liste ne
				soit exhaustive, sont la propriété exclusive de leur auteur et sont protégés à ce titre par le droit d&apos;auteur, le droit des
				marques ou tout autre droit reconnu par les lois en vigueur.
			</Typography>
			<Typography typo={ETypo.TEXT_MD_REGULAR} color={ETypoColor.TEXT_SECONDARY}>
				L&apos;Utilisateur s&apos;interdit de porter atteinte, directement ou indirectement, au droit de propriété de tiers, dont les contenus
				sont présents sur le Site et s&apos;interdit d&apos;exploiter ces éléments de quelque manière que ce soit.
			</Typography>
			<Typography typo={ETypo.TEXT_MD_REGULAR} color={ETypoColor.TEXT_SECONDARY}>
				L&apos;Utilisateur s&apos;engage à respecter l&apos;intégralité des droits de tiers, dont les contenus sont présents sur le Site.
			</Typography>
		</section>
	);
}

export function CGUSection13(): React.JSX.Element {
	const pub = useDeploymentLineLegalPublisher();
	return (
		<section>
			<Typography typo={ETypo.TITLE_H6} color={ETypoColor.TEXT_ACCENT}>
				13. Tolérance
			</Typography>
			<Typography typo={ETypo.TEXT_MD_REGULAR} color={ETypoColor.TEXT_SECONDARY}>
				L&apos;Utilisateur convient que le fait pour {pub.publisherLegalName} de tolérer une situation n&apos;a pas pour effet d&apos;accorder à l&apos;utilisateur
				des droits acquis.
			</Typography>
			<Typography typo={ETypo.TEXT_MD_REGULAR} color={ETypoColor.TEXT_SECONDARY}>
				De plus, une telle tolérance ne peut être interprétée comme une renonciation à faire valoir les droits en cause.
			</Typography>
		</section>
	);
}

export function CGUSection14(): React.JSX.Element {
	return (
		<section>
			<Typography typo={ETypo.TITLE_H6} color={ETypoColor.TEXT_ACCENT}>
				14. Titres
			</Typography>
			<Typography typo={ETypo.TEXT_MD_REGULAR} color={ETypoColor.TEXT_SECONDARY}>
				En cas de difficultés d&apos;interprétation résultant d&apos;une contradiction entre l&apos;un quelconque des titres figurant en tête des
				clauses et l&apos;une quelconque des clauses, les titres seront déclarés inexistants.
			</Typography>
		</section>
	);
}

export function CGUSection15(): React.JSX.Element {
	return (
		<section>
			<Typography typo={ETypo.TITLE_H6} color={ETypoColor.TEXT_ACCENT}>
				15. Nullité
			</Typography>
			<Typography typo={ETypo.TEXT_MD_REGULAR} color={ETypoColor.TEXT_SECONDARY}>
				Si une ou plusieurs stipulations des présentes conditions générales d&apos;utilisation sont tenues pour non valides ou déclarées
				comme telles en application d&apos;une loi, d&apos;un règlement ou à la suite d&apos;une décision passée en force de chose jugée d&apos;une
				juridiction compétente, les autres stipulations garderont toute leur force et leur portée.
			</Typography>
		</section>
	);
}

export function CGUSection16(): React.JSX.Element {
	const pub = useDeploymentLineLegalPublisher();
	return (
		<section>
			<Typography typo={ETypo.TITLE_H6} color={ETypoColor.TEXT_ACCENT}>
				16. Domiciliation
			</Typography>
			<Typography typo={ETypo.TEXT_MD_REGULAR} color={ETypoColor.TEXT_SECONDARY}>
				Pour l&apos;exécution de la présente convention et sauf dispositions particulières, l&apos;Internaute convient d&apos;adresser toute
				correspondance à l&apos;adresse postale de {pub.publisherLegalName} : {pub.postalAddressLine}
			</Typography>
		</section>
	);
}

export function CGUSection17(): React.JSX.Element {
	return (
		<section>
			<Typography typo={ETypo.TITLE_H6} color={ETypoColor.TEXT_ACCENT}>
				17. Langues et compétences
			</Typography>
			<Typography typo={ETypo.TEXT_MD_REGULAR} color={ETypoColor.TEXT_SECONDARY}>
				Les présentes Conditions générales d&apos;utilisation ont été initialement rédigées en français.
			</Typography>
			<Typography typo={ETypo.TEXT_MD_REGULAR} color={ETypoColor.TEXT_SECONDARY}>
				La version française prévaudra sur toute autre traduction en cas de contestation, litige, difficulté d&apos;interprétation ou
				d&apos;exécution des présentes Conditions.
			</Typography>
		</section>
	);
}

export function CGUSection18(): React.JSX.Element {
	return (
		<section>
			<Typography typo={ETypo.TITLE_H6} color={ETypoColor.TEXT_ACCENT}>
				18. Litige
			</Typography>
			<Typography typo={ETypo.TEXT_MD_REGULAR} color={ETypoColor.TEXT_SECONDARY}>
				Compte tenu de la dimension mondiale du réseau Internet, nous vous informons qu&apos;il faut vous conformer à toutes les règles
				applicables dans le pays dans lequel vous résidez.
			</Typography>
			<Typography typo={ETypo.TEXT_MD_REGULAR} color={ETypoColor.TEXT_SECONDARY}>
				Les présentes conditions générales d&apos;utilisation du Site sont régies par la loi française.
			</Typography>
			<Typography typo={ETypo.TEXT_MD_REGULAR} color={ETypoColor.TEXT_SECONDARY}>
				En cas de litige lié à l&apos;interprétation, la validité et les conséquences des présentes CGU et, à défaut de solution amiable
				préalable, les tribunaux de Rennes seront seuls compétents.
			</Typography>
			<Typography typo={ETypo.TEXT_MD_REGULAR} color={ETypoColor.TEXT_SECONDARY}>
				Il en est ainsi pour les règles de fond et les règles de forme et ce, nonobstant les lieux d&apos;exécution des obligations
				substantielles ou accessoires.
			</Typography>
		</section>
	);
}

export function CGUFooter(): React.JSX.Element {
	const pub = useDeploymentLineLegalPublisher();
	return (
		<section>
			<Typography typo={ETypo.TEXT_LG_SEMIBOLD} color={ETypoColor.TEXT_SECONDARY} italic>
				QUESTIONS ? PROBLÈMES ? SUGGESTIONS ?
			</Typography>

			<Typography typo={ETypo.TEXT_MD_REGULAR} color={ETypoColor.TEXT_SECONDARY}>
				Nous vous prions de nous contacter à : ({pub.contactEmail}) ou par courrier à {pub.publisherLegalName}, {pub.postalAddressLine}, France, afin de signaler toute violation des conditions générales d&apos;utilisation ou pour poser toute question
				concernant les CGU,
				<LinkInline
					text="Politique de confidentialité"
					href={buildRoute(Routes.pages.Legal.LegalInformations, { legalUid: ELegalOptions.POLITIQUE_DE_CONFIDENTIALITE })}
				/>
				et/ou le Site.
			</Typography>
		</section>
	);
}
